import axiosRequest from "api";
import { payloadHelper } from "helpers/payload-helper";

import {
  GetBannerListResponse,
  GetMarqueeResponse,
  GetPromotionListResponse,
} from "./type";

export const retriveApi = {
  async getPromotionList() {
    const { data } = await axiosRequest.post<GetPromotionListResponse>(
      "/",
      payloadHelper("PromotionList", null, null, 7),
    );
    return data;
  },
  async getBanner() {
    const { data } = await axiosRequest.post<GetBannerListResponse>(
      "/",
      payloadHelper("Banner", null, null),
    );
    return data;
  },

  async getMarquee() {
    const { data } = await axiosRequest.post<GetMarqueeResponse>(
      "/",
      payloadHelper("Marquee", null, null),
    );
    return data;
  },
};
